import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  plugins: [
    createPersistedState({
      paths: [
        'user.current',
        'auth.isAuthenticated',
        'auth.access_token',
        'auth.refresh_token',
        'auth.maintenance_mode',
        'menu',
        'views',
        'layout',
        'company',
        'qmedia',
        'pressRelease',
      ],
    }),
  ],
});
